import { AP_CHINESE, AP_JAPANESE } from 'chameleon-src/constants/subjects';
/**
 * see https://academicmerit.atlassian.net/browse/FY-11071
 * Japenese and Chinese Subject
 **/
const AUDIO_SUBJECT_CHECK = [AP_CHINESE, AP_JAPANESE];

const isAudioPlaybackCompleteEnabled = (
  enableAudioPlaybackComplete,
  subjectId,
) => enableAudioPlaybackComplete && AUDIO_SUBJECT_CHECK.includes(subjectId);

export default isAudioPlaybackCompleteEnabled;
